import ResourceStatus from '../../application-core/ResourceStatus';
import React from 'react';
import PropTypes from 'prop-types';
import TabbedSubmenu from '../../core/TabbedSubmenu';

class LifeCycle extends React.Component {

    render() {

        const { id, graph, defaultLang, projectIRI, components, onToggleView, useWorkflow, skosXL } = this.props;

        const tabs = useWorkflow ?
            ["Deprecated", "Uncategorised", "Draft", "Rejected"]
            :
            ["Deprecated"];

        let rto = [
            {

                "value": "http://www.w3.org/2004/02/skos/core#Concept",
                "label": "Concept"
            }
        ];
        if (skosXL) {
            rto.push({
                "value": "http://www.w3.org/2008/05/skos-xl#Label",
                "label": "XL Label"
            });
        }

        return (
            <TabbedSubmenu tabs={tabs}>
                <ResourceStatus
                    id={id}
                    key="Deprecated"
                    graph={graph}
                    defaultLang={defaultLang}
                    projectType="TaxonomyProject"
                    entailment={true}
                    onToggleView={onToggleView}
                    predicate="http://www.w3.org/2002/07/owl#deprecated"
                    components={components}
                    within={[
                        "http://www.w3.org/2004/02/skos/core#inScheme"
                    ]}
                    sortProp="prefLabel"
                    labelType={[
                        "http://www.w3.org/2004/02/skos/core#prefLabel"
                    ]}
                    resourceTypeOptions={[
                        {

                            "value": "http://www.w3.org/2004/02/skos/core#Concept",
                            "label": "Concept"
                        }
                    ]}
                    projectIRI={projectIRI}
                    componentIRI={id} />
                {useWorkflow &&
                    <ResourceStatus
                        id={id}
                        key="Uncategorised"
                        graph={graph}
                        defaultLang={defaultLang}
                        projectType="TaxonomyProject"
                        entailment={true}
                        onToggleView={onToggleView}
                        components={components}
                        predicate="https://grafsync.graphifi.com/schema/gs/status"
                        predicateInverted={true}
                        within={[
                            "http://www.w3.org/2004/02/skos/core#inScheme"
                        ]}
                        sortProp="prefLabel"
                        labelType={[
                            "http://www.w3.org/2004/02/skos/core#prefLabel",
                            "http://www.w3.org/2008/05/skos-xl#literalForm"
                        ]}
                        resourceTypeOptions={rto}
                        projectIRI={projectIRI}
                        componentIRI={id} />
                }
                {useWorkflow &&
                    <ResourceStatus
                        id={id}
                        key="Draft"
                        graph={graph}
                        defaultLang={defaultLang}
                        projectType="TaxonomyProject"
                        entailment={true}
                        onToggleView={onToggleView}
                        components={components}
                        predicate="https://grafsync.graphifi.com/schema/gs/status"
                        predicateValue="https://grafsync.graphifi.com/schema/gs/draft"
                        within={[
                            "http://www.w3.org/2004/02/skos/core#inScheme"
                        ]}
                        sortProp="prefLabel"
                        labelType={[
                            "http://www.w3.org/2004/02/skos/core#prefLabel",
                            "http://www.w3.org/2008/05/skos-xl#literalForm"
                        ]}
                        resourceTypeOptions={rto}
                        projectIRI={projectIRI}
                        componentIRI={id} />
                }
                {useWorkflow &&
                    <ResourceStatus
                        id={id}
                        key="Rejected"
                        graph={graph}
                        defaultLang={defaultLang}
                        projectType="TaxonomyProject"
                        entailment={true}
                        onToggleView={onToggleView}
                        components={components}
                        predicate="https://grafsync.graphifi.com/schema/gs/status"
                        predicateValue="https://grafsync.graphifi.com/schema/gs/rejected"
                        within={[
                            "http://www.w3.org/2004/02/skos/core#inScheme"
                        ]}
                        sortProp="prefLabel"
                        labelType={[
                            "http://www.w3.org/2004/02/skos/core#prefLabel",
                            "http://www.w3.org/2008/05/skos-xl#literalForm"
                        ]}
                        resourceTypeOptions={rto}
                        projectIRI={projectIRI}
                        componentIRI={id} />
                }
            </TabbedSubmenu>
        );
    }
}

LifeCycle.defaultProps = {
    components: []
};

LifeCycle.propTypes = {
    entitlements: PropTypes.array.isRequired,
    examples: PropTypes.array,
    components: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    onToggleView: PropTypes.func,
    graph: PropTypes.string.isRequired,
    projectIRI: PropTypes.string.isRequired,
    skosXL: PropTypes.bool.isRequired,
    defaultLang: PropTypes.string.isRequired,
    ontologyProjectAssociation: PropTypes.array
};

export default LifeCycle;